mutation RequestTusVideoUpload(
  $fileName: String!
  $fileSize: Float!
  $contentType: String!
) {
  requestTusVideoUpload(
    fileName: $fileName
    fileSize: $fileSize
    contentType: $contentType
  ) {
    endpoint
    videoUid
    headers {
      name
      value
    }
  }
}
